import { LoadingButton } from "@mui/lab";
import { Dialog, Stack, DialogContent, DialogActions, Button, Typography, Box } from "@mui/material";
import { DialogTitleClosable } from "../../../components/DialogTitleClosable";
import { bhpButtonSx } from "../../../styles/bhpStyles";
import { CardSwapSearchResultDto } from "../dtos/CardSwapSearchResultDto";
import { useContext, useState } from "react";
import VspPortalContext from "../../../store/VspPortalContext";
import CreditCardIcon from '@mui/icons-material/CreditCard';
import UpdateIcon from '@mui/icons-material/Update';
import CancelIcon from '@mui/icons-material/Cancel';
import { useCardSwapHttp } from "../hooks/useCardSwapHttp";
import { CardSwapUpdateDto } from "../dtos/CardSwapUpdateDto";
import { CardSwapStatusCode, cardSwapStatusCodes } from "../enums/CardSwapStatusCode";
import { useCardSwap } from "../hooks/useCardSwap";


type CardCollectNotificationFailedDialogProps = {

    cardSwapSearchResultDto : CardSwapSearchResultDto;
    dialogOpen: boolean;
    onClose: ( isUpdated : boolean ) => void;

};


export const CardCollectNotificationFailedDialog : React.FC< CardCollectNotificationFailedDialogProps > = ( props : CardCollectNotificationFailedDialogProps ) => {

    
    const { cardSwapSearchResultDto, dialogOpen, onClose } = props;
    
    const [ isUpdated, setIsUpdated ] = useState< boolean >( false );
    const [ isUpdating, setIsUpdating ] = useState< boolean >( false );

    const { state } = useContext( VspPortalContext );

    const { updateCardSwap } = useCardSwapHttp( );

    const { cardSwapSearchResult, setCardSwapSearchResult } = useCardSwap( cardSwapSearchResultDto );

    const handleClose = ( ) => {

        if( !isUpdating ) {
            
            if( isUpdated ) {
                
                onClose( true );

            } else {
                
                onClose( false );
                
            }
            
        }

    };


    const handleResendNotificationClick = ( ) => resendNotification( );


    const resendNotification = async( ) => {

        const cardSwapUpdateDto : CardSwapUpdateDto = {

            cardSwapStatusCode : CardSwapStatusCode.ReadyToCollect,
            id : cardSwapSearchResult.id,
            updatedBy : state.username

        };

        setIsUpdating( true );

        const isSuccess = await updateCardSwap( cardSwapUpdateDto );

        setIsUpdating( false );


        if( isSuccess ){
            
            setIsUpdated( true );
            onClose( true );

        }

    };


    return(

        <Dialog
            onClose={ handleClose }
            open={ dialogOpen }
            sx={{ '& .MuiDialog-paper': { minHeight: 435, width: '500px' } }}
        >
            <DialogTitleClosable onClose={ handleClose }>
                <Stack direction="row" display="flex" alignItems="center" gap={ 0.5 }>
                    <CreditCardIcon /> 
                    { cardSwapStatusCodes[ cardSwapSearchResultDto.refCardSwapStatusCode ] }
                </Stack>
            </DialogTitleClosable>

            <DialogContent dividers>
                
                <ul>

                    <li><b>First Name:</b> { cardSwapSearchResult.firstName }</li>
                    <li><b>Last Name:</b> { cardSwapSearchResult.surname }</li>
                    <li><b>Email:</b> { cardSwapSearchResult.email }</li>
                    <li><b>Employee / ERMS ID:</b> { cardSwapSearchResult.employeeNumber }</li>
                    <li><b>Card Collection Village:</b> { cardSwapSearchResult.villageCode }</li>

                </ul>

                <h2>Failed notification card number</h2>

                <Stack direction="row" display="flex" alignItems="center" gap={ 0.5 }>
                    
                    <Typography sx={{ lineHeight: '45px' }}>
                        { cardSwapSearchResult.newCardNumber }
                    </Typography>

                    <Box sx={{ flexGrow: 1 }} />

                    <LoadingButton
                        disabled={ isUpdated || isUpdating }
                        loading={ isUpdating }
                        loadingPosition="start"
                        onClick={ handleResendNotificationClick } 
                        startIcon={ <UpdateIcon /> }
                        sx={{ ...bhpButtonSx }} 
                        variant="contained"
                    >
                        Resend Notification
                    </LoadingButton>


                </Stack>

            </DialogContent>
            
            <DialogActions>
                <Button 
                    disabled={ isUpdating }
                    onClick={ handleClose } 
                    startIcon={ <CancelIcon /> }
                    sx={{ ...bhpButtonSx, width: '100px' }} 
                >
                    { cardSwapSearchResultDto.refCardSwapStatusCode == cardSwapSearchResult.refCardSwapStatusCode ? 'Close' : 'OK' }
                </Button>
            </DialogActions>

        </Dialog>

    );

};